import React from "react";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { redirectTo } from "../../../util/redirect";
import { Link, withRouter } from "react-router-dom";
import master from "../../../static/images/master.svg";
import { Logout } from "../../../services/graphql/queries/auth";
import {
  loginAction,
  addPermission,
} from "../../../services/redux/actions/loginActions";
import { GET_PERMISSION } from "../../../services/graphql/queries/accessPermission";
import { isMobileOnly } from "react-device-detect";
import CategoryManagementImage from "../../../static/images/category.svg";
import { MdOutlineFolderCopy } from "react-icons/md";

class SideBar extends React.Component {
  constructor(props) {
    super(props);
  }

  logoutHelper = () => {
    let userType = localStorage.getItem("userType");

    if (userType == "1") {
      localStorage.clear();
      this.props.history.push("/");
      // this.props.history.push("/");
    } else {
      localStorage.clear();
      this.props.history.push("/");
    }
    this.props.dispatch(loginAction());

    window.close();
  };

  logout = () => {
    // let commonLoginFlag = false;
    // if (localStorage.getItem("commonLogin")) {
    //   commonLoginFlag = localStorage.getItem("commonLogin");
    // }
    // if (commonLoginFlag === false) {
    this.props.client
      .mutate({
        mutation: Logout,
        variables: { logoutBy: 1 },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        console.log("result@@", result.data.logout.message);
        // this.logoutHelper();
      })
      .then(() => {
        this.logoutHelper();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // localStorage.clear();
  // })
  // .catch((error) => {
  //   console.log("~~~error: ", error);
  // });
  // debugger;

  // this.props.history.push("/login");
  // this.props.addPermission({});
  // redirectTo("/");
  // let userType = localStorage.getItem("userType");
  // console.log("!!!!!!!!!!!!!!", userType);
  // if (userType == "1") {
  //   this.props.history.push("/");
  // } else if (userType == "2") {
  //   this.props.history.push("/doc-workflow-login");
  // } else if (userType == "3") {
  //   this.props.history.push("/compliance-bi-login");
  // }
  // localStorage.clear();

  getPermission() {
    this.props.client
      .query({
        query: GET_PERMISSION,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log("nav permission ", JSON.parse(result.data.getPermission));
        this.setState(
          {
            accessPermission: JSON.parse(result.data.getPermission),
            loading: true,
          },
          () => {
            this.props.dispatch(addPermission(this.state.accessPermission));
          }
        );
      })
      .catch((error) => {
        this.props.dispatch(addPermission({}));
        console.log("~~~error: ", error);
      });
  }
  componentDidMount() {
    if (!Object.keys(this.props.permission).length) {
      this.getPermission();
    }
    // this.getPermission();
  }

  render() {
    const accessPermission = this.props.permission;
    console.log("accessPermission", accessPermission);
    const userType = localStorage.getItem("userType");
    return (
      <section
        className={`nav-section ${this.props.expandMenuClass}`}
        style={{ overflowY: "auto", overflowX: "hidden" }}
      >
        <ul className="list-unstyled">
          {accessPermission && accessPermission[100] ? (
            <li title="User Management">
              <Link to="/users-view">
                <figure>
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <path
                        data-color="color-2"
                        d="M14.5,12.976a1,1,0,0,0-.426-.82A10.367,10.367,0,0,0,8,10.5a10.367,10.367,0,0,0-6.074,1.656,1,1,0,0,0-.426.82V15.5h13Z"
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx={8}
                        cy={4}
                        r="3.5"
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                </figure>
                <span>User Mgmt.</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {accessPermission && accessPermission[200] ? (
            <li 
              data-toggle="tooltip"
              data-placement="bottom" 
              title="Project"
              >  
              <Link to="/category-list">
                <figure>
                  {/* <img src={CategoryManagementImage} /> */}
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <circle fill="#69951a" cx="2.5" cy="3.5" r="1.5"></circle>
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="5"
                        y1="3.5"
                        x2="14"
                        y2="3.5"
                      ></line>
                      <circle fill="#69951a" cx="2.5" cy="8" r="1.5"></circle>
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="5"
                        y1="8"
                        x2="14"
                        y2="8"
                      ></line>
                      <circle
                        fill="#69951a"
                        cx="2.5"
                        cy="12.5"
                        r="1.5"
                      ></circle>
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="5"
                        y1="12.5"
                        x2="14"
                        y2="12.5"
                      ></line>
                    </g>
                  </svg>
                </figure>
                <span>Project</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {accessPermission && accessPermission[244] ? (
            <li
              data-toggle="tooltip"
              data-placement="bottom"
              title="Project Folder"
            >
              <Link to="/project-folder-list">
                <figure>
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="4.5"
                        y1="11.5"
                        x2="11.5"
                        y2="11.5"
                        // data-color="#69951a"
                      ></line>
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="4.5"
                        y1="5.5"
                        x2="11.5"
                        y2="5.5"
                        // data-color="color-2"
                      ></line>
                      <polygon
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                      ></polygon>
                    </g>
                  </svg>
                </figure>
                <span>Project Folder</span>
              </Link>
            </li>
          ) : (
            ""
          )}

          {accessPermission && accessPermission[190] ? (
            <li
              data-toggle="tooltip"
              data-placement="bottom"
              title="Doc - Upload"
            >
              <Link to="/category-document-upload-list">
                <figure>
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <polygon
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        points="2,2 14,2 14,14 2,14 2,2"
                      ></polygon>
                      <path
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        d="M8,12 L8,6"
                      ></path>
                      <polygon
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        points="6,7 8,5 10,7"
                      ></polygon>
                    </g>
                  </svg>
                </figure>
                <span>Doc - Upload</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {accessPermission && accessPermission[191] ? (
            <li
              data-toggle="tooltip"
              data-placement="bottom"
              title="Doc - View"
            >
              <Link to="/category-info-view">
                <figure>
                  {/* <img src={CategoryManagementImage} /> */}
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="4.5"
                        y1="11.5"
                        x2="11.5"
                        y2="11.5"
                        data-color="color-2"
                      ></line>
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="4.5"
                        y1="8.5"
                        x2="11.5"
                        y2="8.5"
                        data-color="color-2"
                      ></line>
                      <line
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        x1="4.5"
                        y1="5.5"
                        x2="6.5"
                        y2="5.5"
                        data-color="color-2"
                      ></line>
                      <polygon
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                      ></polygon>
                      <polyline
                        fill="none"
                        stroke="#69951a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        points="9.5,0.5 9.5,5.5 14.5,5.5 "
                      ></polyline>
                    </g>
                  </svg>
                </figure>
                <span>Doc - View</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {accessPermission && accessPermission[243] ? (
            <li
              data-toggle="tooltip"
              data-placement="bottom"
              title="Doc - Search"
            >
              <Link to="/category-info-attachment-list">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <circle
                        cx="6"
                        cy="6"
                        r="5"
                        stroke="#69951a"
                        strokeWidth="1.5"
                        fill="none"
                      />
                      <line
                        x1="9"
                        y1="9"
                        x2="14"
                        y2="14"
                        stroke="#69951a"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </g>
                  </svg>
                </figure>
                <span>Doc - Search</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {accessPermission && accessPermission[246] ? (
            <li title="Folder Copy">
              <Link to="/folder-copy">
                <figure>
                  {/* <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g transform="translate(0, 0)">
                      <path
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M4 4H10L12 6H20C21.1 6 22 6.9 22 8V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                      />
                      <path
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6 17H18"
                      />
                    </g>
                  </svg> */}
                  <MdOutlineFolderCopy style={{width:"18px", height:"18px", color:"#69951a"}}/>
                </figure>
                <span>Folder Copy</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {accessPermission && accessPermission[170] ? (
            <li title="Masters">
              <Link to="/masters-list">
                <figure>
                  {/* <img src={master} /> */}
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                  >
                    <g transform="translate(0, 0)">
                      <circle
                        data-color="color-2"
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        cx={8}
                        cy={8}
                        r="2.5"
                      />
                      <path
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        d="M15.5,9V7 l-2.177-0.363c-0.131-0.512-0.332-0.994-0.595-1.437l1.283-1.796L12.596,1.99L10.8,3.272c-0.443-0.263-0.925-0.464-1.437-0.595 L9,0.5H7L6.637,2.677C6.125,2.808,5.643,3.009,5.2,3.272L3.404,1.99L1.99,3.404L3.272,5.2C3.009,5.643,2.808,6.125,2.677,6.637 L0.5,7v2l2.177,0.363c0.131,0.512,0.332,0.994,0.595,1.437L1.99,12.596l1.414,1.414L5.2,12.728c0.443,0.263,0.925,0.464,1.437,0.595 L7,15.5h2l0.363-2.177c0.512-0.131,0.994-0.332,1.437-0.595l1.796,1.283l1.414-1.414L12.728,10.8 c0.263-0.443,0.464-0.925,0.595-1.437L15.5,9z"
                      />
                    </g>
                  </svg>
                </figure>
                <span>Masters</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {Object.keys(accessPermission).length === 0 ? null : (
            <li title="Logout">
              <a
                href="#"
                onClick={() => {
                  this.logout();
                }}
              >
                <figure>
                  <svg
                    x="0px"
                    y="0px"
                    width="18px"
                    height="18px"
                    viewBox="0 0 16 16"
                    style={{ transform: "rotate(90deg)" }}
                  >
                    <g transform="translate(0, 0)">
                      <polygon
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        points="12.5,5.5 8,0.5 3.5,5.5 6.5,5.5 6.5,11.5 9.5,11.5 9.5,5.5 "
                        data-color="color-2"
                      />
                      <path
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.5,10.5v4c0,0.552-0.448,1-1,1h-13 c-0.552,0-1-0.448-1-1v-4"
                      />
                    </g>
                  </svg>
                </figure>
                <span>Logout</span>
              </a>
            </li>
          )}
        </ul>
      </section>
    );
  }
}
const mapStateToProps = (state) => ({
  ...state,
  permission: state.auth.permission,
});
export default connect(mapStateToProps)(withRouter(withApollo(SideBar)));
